import { useEffect } from "react"
import { useBlocker } from "react-router-dom"
import { Alert, Button, Dialog, DialogActions, DialogContent } from "@mui/material"
import { useAtomValue } from "jotai"
import { nonblockAtom } from "store/commonAtoms"


const Blocker = () => {
    const nonblock = useAtomValue(nonblockAtom)
    const blocker = useBlocker(({ currentLocation, nextLocation }) => {
        const current = currentLocation.pathname
        const next = nextLocation.pathname
        // 下書き保存でURLが変更される場合、またはプレビュー画面に遷移時はブロック対象外とする
        if ((/submission\/pdf$/.test(current) && /submission\/pdf\/[^/]+$/.test(next))
            || (/submission\/html$/.test(current) && /submission\/html\/[^/]+$/.test(next))
            || (/submission\/text\/new\/[^/]+$/.test(current) && /submission\/text\/[^/]+$/.test(next))
            || (/submission\/pdf\/new\/[^/]+$/.test(current) && /submission\/pdf\/[^/]+$/.test(next))
            || (/submission/.test(current) && /submission\/preview$/.test(next))
            || (/entry\/[^/]+$/.test(current) && /entry\/[^/]+\/[^/]+$/.test(next))
            || (/entry/.test(current) && /entry\/[^/]+\/preview+$/.test(next))
            || (/pranalysis$/.test(current) && /pranalysis\/history$/.test(next))
         ) {
            return false
        }
        return current !== next
    })

    useEffect(() => {
        if (blocker.state === "blocked" && nonblock) {
            blocker.proceed()
        }
    }, [blocker, nonblock])


    return (
        <Dialog
            open={blocker.state === "blocked"}
            closeAfterTransition={true}
            disableRestoreFocus={true}
            maxWidth="xs"
            onClose={() => blocker.reset()}
        >
            <DialogContent
                dividers={true}
            >
                <Alert
                    severity="warning"
                >
                    このままページを移動すると編集内容は保存されません。移動しますか？
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => blocker.reset()}
                >
                    いいえ
                </Button>
                <Button
                    variant="contained"
                    onClick={() => blocker.proceed()}
                >
                    はい
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default Blocker
